import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { VerticalCardLoader } from 'syf-component-library/ui/atoms';
import { OwnRewardsClients } from '../../../../../const/clients';
import ShopMore from '../../../../RewardsPage/ui/molecules/ShopMore';
import { PageType, SNAPSHOT } from '../../../../../const/analytics';
import { useRewardsConfigContext } from '../../../../../context/rewardsConfig';
import { getSelectedAccountId } from '../../../../../helpers/sessionAccountId';
import useRewards from '../../../../../hooks/useRewards';
import useRewardsAnalytics from '../../../../../hooks/useRewardsAnalytics';
import ErrorPage from '../../../../../ui/templates/ErrorPage';
import ModalContentWrapper from './ModalContentWrapper';
import ModalRewardsFaqs from './ModalRewardsFaqs';
import ModalRewardsProgressAndEarnings from './ModalRewardsProgressAndEarnings';
import { FaqSnapshotWrapper, LoadingWrapper, ShopMoreWrapper } from './subcomponents';
var ModalContent = function () {
    var config = useRewardsConfigContext().config;
    var selectedAccountId = getSelectedAccountId();
    if (!selectedAccountId) {
        throw new Error('selectedAccountId is not defined');
    }
    var _a = useRewards(), allRewardsCertificate = _a.allRewardsCertificate, clientId = _a.clientId, isError = _a.isError, isLoading = _a.isLoading;
    useRewardsAnalytics({
        allRewardsCertificate: allRewardsCertificate,
        pageSubFunction: SNAPSHOT,
        clientName: clientId,
        pageType: PageType.Snapshot
    });
    if (isError) {
        return (_jsx(ErrorPage, { config: config, analyticsEventOptions: {
                pageSubFunction: SNAPSHOT,
                clientName: clientId
            } }));
    }
    if (isLoading) {
        return (_jsx(LoadingWrapper, { children: _jsx(VerticalCardLoader, {}) }));
    }
    if (clientId in OwnRewardsClients) {
        return (_jsx(ModalContentWrapper, { children: _jsxs(ShopMoreWrapper, { children: [_jsx(ShopMore, { className: "inside-drawer" }), _jsx(FaqSnapshotWrapper, { children: _jsx(ModalRewardsFaqs, {}) })] }) }));
    }
    return (_jsxs(ModalContentWrapper, { children: [_jsx(ModalRewardsProgressAndEarnings, {}), _jsx(ModalRewardsFaqs, {})] }));
};
export default ModalContent;
